import './style.scss';
import { CalendarHelper } from '../../../../../../../../helpers/calendar.helper';
import { AnalyticsService } from '../../../../../../../../services/analytics-service';
import { TranslationService } from '../../../../../../../../services/translation.service';
import type { IJourney } from '../../../../../../../../models/journey.model';

function downloadFile(fileName: string, data: string): void {
  const blob = new Blob([data], { type: 'text/calendar' });
  const elem = window.document.createElement('a');
  elem.href = window.URL.createObjectURL(blob);
  elem.download = fileName;
  elem.target = '_blank';
  document.body.appendChild(elem);
  elem.click();
  document.body.removeChild(elem);
}

function CalendarDownloads({ journey }: { journey: IJourney }) {
  return (
    <div className="calendar-downloads pt-3">
      <a
        href={CalendarHelper.GenerateGoogleCalendarLink(journey)}
        target="_blank"
        rel="noreferrer"
        onClick={() => {
          AnalyticsService.addEvent(AnalyticsService.TravelPlannerCategory, 'Detaljvy - Kalender - Lägg till', 'Google Calendar');
        }}
      >
        {TranslationService.get('travelplanner.calendardownloadgooglelinktext')}
      </a>
      <button
        className="btn--as-link btn--outline-internal"
        onClick={() => {
          const ics = CalendarHelper.CreateIcsFile(journey);
          downloadFile('event.ics', ics);
          AnalyticsService.addEvent(AnalyticsService.TravelPlannerCategory, 'Detaljvy - Kalender - Lägg till', 'Apple Calendar');
        }}
      >
        {TranslationService.get('travelplanner.calendardownloadapplelinktext')}
      </button>
      <button
        className="btn--as-link btn--outline-internal"
        onClick={() => {
          const ics = CalendarHelper.CreateIcsFile(journey);
          downloadFile('event.ics', ics);
          AnalyticsService.addEvent(AnalyticsService.TravelPlannerCategory, 'Detaljvy - Kalender - Lägg till', 'Outlook');
        }}
      >
        {TranslationService.get('travelplanner.calendardownloadoutlooklinktext')}
      </button>
    </div>
  );
}

export default CalendarDownloads;
